// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","savedSearchLinkArea":"_9KnAZGfv4pquSzHvc1uiU","savedSearchText":"_35NgzcGy60tr4eKLWR1mDh"};